import { isImageMime, type PendingAtt } from './attachments';

/* Preview thumbnail for a pending attachment (image preview or document icon) */
/* with a remove button. Extracted verbatim from Chat.tsx (decomposition). */
export function PendingThumb({ att, onRemove }: { att: PendingAtt; onRemove: () => void }) {
  return (
    <div className="relative w-[64px] h-[64px] rounded-[12px] overflow-hidden border border-border shadow-card">
      {isImageMime(att.file.type) ? (
        <img src={att.previewUrl} alt="" className="w-full h-full object-cover" />
      ) : (
        <div title={att.file.name} className="w-full h-full flex flex-col items-center justify-center gap-[2px] bg-naia-card-alt text-[22px]">
          📄
          <span className="text-[8px] font-bold max-w-[58px] overflow-hidden text-ellipsis whitespace-nowrap">{att.file.name}</span>
        </div>
      )}
      <button
        type="button"
        onClick={onRemove}
        aria-label="Retirer la pièce jointe"
        className="absolute top-[2px] right-[2px] w-[22px] h-[22px] rounded-full bg-naia-navy text-card border-none text-[14px] font-extrabold cursor-pointer leading-none grid place-items-center font-[inherit]"
      >
        ×
      </button>
    </div>
  );
}
